import { action, observable } from "mobx";

export type SuggestionEntryMap = {
  [key: string]: {
    type: string;
    repeated: boolean;
    fields: SuggestionEntryMap;
  };
};

export interface SuggestionEntry {
  key: string;
  type: string;
  repeated: boolean;
  fields: SuggestionEntry[];
}

export class Suggestion {
  @observable accessor isOpened = false;
  @observable accessor isLoading = false;
  @observable accessor suggestions: SuggestionEntry[] = [];
  @observable accessor limit = 1000;
  @observable accessor env = "dd1";

  @action changeLimit(limit: string) {
    const newLimit = parseInt(limit, 10);
    if (!Number.isNaN(newLimit)) {
      this.limit = newLimit;
    }
  }
}
